export default __webpack_public_path__ + "partner_50905d5.png";